export default __webpack_public_path__ + "static/media/golden-check-mark.63fb2b5f.svg";